<template><div><h1 id="lieferantenstamm" tabindex="-1"><a class="header-anchor" href="#lieferantenstamm"><span>Lieferantenstamm</span></a></h1>
<p>Lieferantenstamm — Verwaltung des Lieferantenstamms</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Im Lieferantenstamm werden einzelne Adressen als Lieferanten gekennzeichnet und zusätzliche, lieferantenspezifische Daten gepflegt.</p>
<p>Pfad: <code v-pre>Logistik → Lieferanten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<p>Die Daten werden in der Reihenfolge dargestellt, wie sie beim Erfassen eines neuen Lieferanten eingegeben werden können.</p>
<dl>
<dt>AdressNr:</dt>
<dd>Personen-ID</dd>
<dt>Name etc.:</dt>
<dd>Anzeige der wichtigsten Adressdaten</dd>
<dt>ZahlFrist:</dt>
<dd>Zahlungsfrist in Tagen</dd>
<dt>Skto:</dt>
<dd>Skonto in Prozent, Eingabe von 3 Skonto-Stufen ist möglich</dd>
<dt>Tage:</dt>
<dd>Skonto-Tage, beziehen sich jeweils auf die Skontoprozente</dd>
<dt>Postcheck:</dt>
<dd>Postcheck-Kontonummer</dd>
<dt>BankClear:</dt>
<dd>Clearingnummer des Lieferanten</dd>
<dt>MarkSchutz:</dt>
<dd>Markenschutzerklärung vorhanden? j/n</dd>
<dt>KatBeitrag:</dt>
<dd>Katalogbeitrag; manuell zu pflegen. Beitrag, den der Lieferant an die Druckkosten des Katalogs versprochen hat</dd>
<dt>Bemerkung:</dt>
<dd>Freies Textfeld, 60 Zeichen, alphanumerisch</dd>
<dt>Lieferantenbestellung-Schlusstext:</dt>
<dd>Freies Textfeld, mehrzeilig, kann bei Bestellungen beim Lieferanten im Schlusstext verwendet werden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


